import { Enums } from "../thor.enums";

export namespace paymentT {
    export enum PaymentMethod {
        DIRECT = "direct", // directe
        LINK = "link" // lien 3DS
    }

    export enum PaymentNature {
        DEPOSIT = "deposit", // acompte
        INTEGRAL_PAYMENT = "integral_payment" // paiement intégral
    }

    export enum PaymentType {
        ITEM = "item", // bordereau
        DELIVERY = "delivery" // expédition
    }

    export enum LinkPaymentStatus {
        PENDING = "pending", // en attente
        SUCCESS = "success", // réglé
        DELETED = "deleted" // supprimé
    }

    export interface Payment {
        id: number;
        contract_id: number;
        items_ids: number[];
        organization_id: number;
        sale_id: number;
        user_id: string;
        amount: string;
        card: PaymentCard;
        is_caution: boolean;
        nature: PaymentNature;
        type: PaymentType;
        method: PaymentMethod;
        created: string;
        updated?: string;
        link_payment_id?: number;
        link_payment?: LinkPayment;
        organization_comment?: string;
    }

    export interface PaymentCard {
        brand: string;
        iin?: string;
        last4: string;
        exp_month: number;
        exp_year: number;
    }

    export interface LinkPayment {
        id?: number;
        token?: string;
        status: LinkPaymentStatus;
        created: string;
        expiration_date: string;
        paid_date?: string;
        deleted_at?: string;
        relaunched_dates?: string[];
    }

    export namespace thor {
        export enum LinkPaymentStateType {
            DELIVERY = "delivery", // livraison
            DEPOSIT = "deposit", // acompte
            ITEM = "item" // bordereau
        }

        export interface LinkPaymentState {
            id: number;
            label: string;
            type: LinkPaymentStateType;
            status: LinkPaymentStatus;
            amount: number;
            nature?: PaymentNature;
            created: string;
            expiration_date: string;
            has_expired?: boolean;
            last_relaunched_date?: string;
        }

        export interface LinkPaymentPost {
            user_id: string;
            contract_id: number;
            items_ids: number[];
            sale_id: number;
            amount: number;
            nature: PaymentNature;
            type: LinkPaymentStateType;
            organization_comment: string;
        }
    }
}

export enum StripeContractStatus {
    Activated = "activated",
    Disabled = "disabled",
    EventuallyDue = "eventually_due",
    Pending = "pending",
    RestrictedSoon = "restricted_soon"
}

export interface StripeContract {
    id?: number;
    created?: string;
    updated?: string | unknown;
    organization_id?: number;
    type?: Enums.OrganizationContract;
    provider?: "stripe";
    provider_infos?: { [key: string]: unknown }; // cf https://stripe.com/docs/api/accounts/object
    options?: unknown;
    is_deleted?: false;
    missing_information?: boolean;
    disabled?: boolean;
    status: StripeContractStatus;
}

export interface MonextContract {
    id?: number;
    organization_id?: number;
    type?: Enums.OrganizationContract;
    provider?: Enums.PaymentPlatform.Monext;
    provider_infos?: MonextProviderInfos;
    options?: { [key: string]: unknown };
    is_deleted: boolean;
    created: Date;
    updated: Date;
    disabled: boolean;
    status: StripeContractStatus;
}

export interface MonextProviderInfos {
    vad_contract_id: string;
    point_of_sale_reference: string;
}

